import React from 'react';

import UserLogItem from '../UserLogItem/UserLogItem';

const UserLogList = ({ logs, user, users }) => (
  <div>
    {logs.length > 0 ? (
      logs.map((log) => (
        <UserLogItem key={log.id} log={log} user={user} users={users} />
      ))
    ) : (
      <div className="text-center">No Logs yet</div>
    )}
  </div>
);

export default UserLogList;
